import { render, staticRenderFns } from "./inviteOfferLetterDialog.vue?vue&type=template&id=2b234830&scoped=true"
import script from "./inviteOfferLetterDialog.vue?vue&type=script&lang=js"
export * from "./inviteOfferLetterDialog.vue?vue&type=script&lang=js"
import style0 from "./inviteOfferLetterDialog.vue?vue&type=style&index=0&id=2b234830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b234830",
  null
  
)

export default component.exports